// Generated by Haxe 3.4.7
(function ($hx_exports, $global) {
	'use strict';
	$hx_exports['oneconnect'] = $hx_exports['oneconnect'] || {};
	var $estr = function () {
		return js_Boot.__string_rec(this, '');
	};

	function $extend(from, fields) {
		function Inherit() {}

		Inherit.prototype = from;
		var proto = new Inherit();
		for (var name in fields) proto[name] = fields[name];
		if (fields.toString !== Object.prototype.toString)
			proto.toString = fields.toString;
		return proto;
	}

	var EReg = function (r, opt) {
		this.r = new RegExp(r, opt.split('u').join(''));
	};
	EReg.__name__ = ['EReg'];
	EReg.prototype = {
		match: function (s) {
			if (this.r.global) {
				this.r.lastIndex = 0;
			}
			this.r.m = this.r.exec(s);
			this.r.s = s;
			return this.r.m != null;
		},
		__class__: EReg,
	};
	var HxOverrides = function () {};
	HxOverrides.__name__ = ['HxOverrides'];
	HxOverrides.cca = function (s, index) {
		var x = s.charCodeAt(index);
		if (x != x) {
			return undefined;
		}
		return x;
	};
	HxOverrides.substr = function (s, pos, len) {
		if (len == null) {
			len = s.length;
		} else if (len < 0) {
			if (pos == 0) {
				len = s.length + len;
			} else {
				return '';
			}
		}
		return s.substr(pos, len);
	};
	HxOverrides.iter = function (a) {
		return {
			cur: 0,
			arr: a,
			hasNext: function () {
				return this.cur < this.arr.length;
			},
			next: function () {
				return this.arr[this.cur++];
			},
		};
	};
	Math.__name__ = ['Math'];
	var Std = function () {};
	Std.__name__ = ['Std'];
	Std.string = function (s) {
		return js_Boot.__string_rec(s, '');
	};
	var Type = function () {};
	Type.__name__ = ['Type'];
	Type.getClassName = function (c) {
		var a = c.__name__;
		if (a == null) {
			return null;
		}
		return a.join('.');
	};
	var haxe_IMap = function () {};
	haxe_IMap.__name__ = ['haxe', 'IMap'];
	var haxe_Resource = function () {};
	haxe_Resource.__name__ = ['haxe', 'Resource'];
	haxe_Resource.getBytes = function (name) {
		var _g = 0;
		var _g1 = haxe_Resource.content;
		while (_g < _g1.length) {
			var x = _g1[_g];
			++_g;
			if (x.name == name) {
				if (x.str != null) {
					return haxe_io_Bytes.ofString(x.str);
				}
				return haxe_crypto_Base64.decode(x.data);
			}
		}
		return null;
	};
	var haxe_io_Bytes = function (data) {
		this.length = data.byteLength;
		this.b = new Uint8Array(data);
		this.b.bufferValue = data;
		data.hxBytes = this;
		data.bytes = this.b;
	};
	haxe_io_Bytes.__name__ = ['haxe', 'io', 'Bytes'];
	haxe_io_Bytes.ofString = function (s) {
		var a = [];
		var i = 0;
		while (i < s.length) {
			var c = s.charCodeAt(i++);
			if (55296 <= c && c <= 56319) {
				c = ((c - 55232) << 10) | (s.charCodeAt(i++) & 1023);
			}
			if (c <= 127) {
				a.push(c);
			} else if (c <= 2047) {
				a.push(192 | (c >> 6));
				a.push(128 | (c & 63));
			} else if (c <= 65535) {
				a.push(224 | (c >> 12));
				a.push(128 | ((c >> 6) & 63));
				a.push(128 | (c & 63));
			} else {
				a.push(240 | (c >> 18));
				a.push(128 | ((c >> 12) & 63));
				a.push(128 | ((c >> 6) & 63));
				a.push(128 | (c & 63));
			}
		}
		return new haxe_io_Bytes(new Uint8Array(a).buffer);
	};
	haxe_io_Bytes.prototype = {
		getString: function (pos, len) {
			if (pos < 0 || len < 0 || pos + len > this.length) {
				throw new js__$Boot_HaxeError(haxe_io_Error.OutsideBounds);
			}
			var s = '';
			var b = this.b;
			var fcc = String.fromCharCode;
			var i = pos;
			var max = pos + len;
			while (i < max) {
				var c = b[i++];
				if (c < 128) {
					if (c == 0) {
						break;
					}
					s += fcc(c);
				} else if (c < 224) {
					s += fcc(((c & 63) << 6) | (b[i++] & 127));
				} else if (c < 240) {
					s += fcc(((c & 31) << 12) | ((b[i++] & 127) << 6) | (b[i++] & 127));
				} else {
					var u =
						((c & 15) << 18) |
						((b[i++] & 127) << 12) |
						((b[i++] & 127) << 6) |
						(b[i++] & 127);
					s += fcc((u >> 10) + 55232);
					s += fcc((u & 1023) | 56320);
				}
			}
			return s;
		},
		toString: function () {
			return this.getString(0, this.length);
		},
		__class__: haxe_io_Bytes,
	};
	var haxe_crypto_Base64 = function () {};
	haxe_crypto_Base64.__name__ = ['haxe', 'crypto', 'Base64'];
	haxe_crypto_Base64.encode = function (bytes, complement) {
		if (complement == null) {
			complement = true;
		}
		var str = new haxe_crypto_BaseCode(haxe_crypto_Base64.BYTES)
			.encodeBytes(bytes)
			.toString();
		if (complement) {
			switch (bytes.length % 3) {
				case 1:
					str += '==';
					break;
				case 2:
					str += '=';
					break;
				default:
			}
		}
		return str;
	};
	haxe_crypto_Base64.decode = function (str, complement) {
		if (complement == null) {
			complement = true;
		}
		if (complement) {
			while (HxOverrides.cca(str, str.length - 1) == 61)
				str = HxOverrides.substr(str, 0, -1);
		}
		return new haxe_crypto_BaseCode(haxe_crypto_Base64.BYTES).decodeBytes(
			haxe_io_Bytes.ofString(str)
		);
	};
	var haxe_crypto_BaseCode = function (base) {
		var len = base.length;
		var nbits = 1;
		while (len > 1 << nbits) ++nbits;
		if (nbits > 8 || len != 1 << nbits) {
			throw new js__$Boot_HaxeError(
				'BaseCode : base length must be a power of two.'
			);
		}
		this.base = base;
		this.nbits = nbits;
	};
	haxe_crypto_BaseCode.__name__ = ['haxe', 'crypto', 'BaseCode'];
	haxe_crypto_BaseCode.prototype = {
		encodeBytes: function (b) {
			var nbits = this.nbits;
			var base = this.base;
			var size = ((b.length * 8) / nbits) | 0;
			var out = new haxe_io_Bytes(
				new ArrayBuffer(size + ((b.length * 8) % nbits == 0 ? 0 : 1))
			);
			var buf = 0;
			var curbits = 0;
			var mask = (1 << nbits) - 1;
			var pin = 0;
			var pout = 0;
			while (pout < size) {
				while (curbits < nbits) {
					curbits += 8;
					buf <<= 8;
					buf |= b.b[pin++];
				}
				curbits -= nbits;
				out.b[pout++] = base.b[(buf >> curbits) & mask] & 255;
			}
			if (curbits > 0) {
				out.b[pout++] = base.b[(buf << (nbits - curbits)) & mask] & 255;
			}
			return out;
		},
		initTable: function () {
			var tbl = [];
			var _g = 0;
			while (_g < 256) tbl[_g++] = -1;
			var _g1 = 0;
			var _g2 = this.base.length;
			while (_g1 < _g2) {
				var i = _g1++;
				tbl[this.base.b[i]] = i;
			}
			this.tbl = tbl;
		},
		decodeBytes: function (b) {
			var nbits = this.nbits;
			if (this.tbl == null) {
				this.initTable();
			}
			var tbl = this.tbl;
			var size = (b.length * nbits) >> 3;
			var out = new haxe_io_Bytes(new ArrayBuffer(size));
			var buf = 0;
			var curbits = 0;
			var pin = 0;
			var pout = 0;
			while (pout < size) {
				while (curbits < 8) {
					curbits += nbits;
					buf <<= nbits;
					var i = tbl[b.b[pin++]];
					if (i == -1) {
						throw new js__$Boot_HaxeError('BaseCode : invalid encoded char');
					}
					buf |= i;
				}
				curbits -= 8;
				out.b[pout++] = (buf >> curbits) & 255 & 255;
			}
			return out;
		},
		__class__: haxe_crypto_BaseCode,
	};
	var haxe_ds_Either = { __ename__: true, __constructs__: ['Left', 'Right'] };
	haxe_ds_Either.Left = function (v) {
		var $x = ['Left', 0, v];
		$x.__enum__ = haxe_ds_Either;
		$x.toString = $estr;
		return $x;
	};
	haxe_ds_Either.Right = function (v) {
		var $x = ['Right', 1, v];
		$x.__enum__ = haxe_ds_Either;
		$x.toString = $estr;
		return $x;
	};
	var haxe_ds_StringMap = function () {
		this.h = {};
	};
	haxe_ds_StringMap.__name__ = ['haxe', 'ds', 'StringMap'];
	haxe_ds_StringMap.__interfaces__ = [haxe_IMap];
	haxe_ds_StringMap.prototype = {
		setReserved: function (key, value) {
			if (this.rh == null) {
				this.rh = {};
			}
			this.rh['$' + key] = value;
		},
		getReserved: function (key) {
			if (this.rh == null) {
				return null;
			} else {
				return this.rh['$' + key];
			}
		},
		keys: function () {
			return HxOverrides.iter(this.arrayKeys());
		},
		arrayKeys: function () {
			var out = [];
			for (var key in this.h) {
				if (this.h.hasOwnProperty(key)) {
					out.push(key);
				}
			}
			if (this.rh != null) {
				for (var key in this.rh) {
					if (key.charCodeAt(0) == 36) {
						out.push(key.substr(1));
					}
				}
			}
			return out;
		},
		__class__: haxe_ds_StringMap,
	};
	var haxe_io_Error = {
		__ename__: true,
		__constructs__: ['Blocked', 'Overflow', 'OutsideBounds', 'Custom'],
	};
	haxe_io_Error.Blocked = ['Blocked', 0];
	haxe_io_Error.Blocked.toString = $estr;
	haxe_io_Error.Blocked.__enum__ = haxe_io_Error;
	haxe_io_Error.Overflow = ['Overflow', 1];
	haxe_io_Error.Overflow.toString = $estr;
	haxe_io_Error.Overflow.__enum__ = haxe_io_Error;
	haxe_io_Error.OutsideBounds = ['OutsideBounds', 2];
	haxe_io_Error.OutsideBounds.toString = $estr;
	haxe_io_Error.OutsideBounds.__enum__ = haxe_io_Error;
	haxe_io_Error.Custom = function (e) {
		var $x = ['Custom', 3, e];
		$x.__enum__ = haxe_io_Error;
		$x.toString = $estr;
		return $x;
	};
	var js__$Boot_HaxeError = function (val) {
		Error.call(this);
		this.val = val;
		this.message = String(val);
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, js__$Boot_HaxeError);
		}
	};
	js__$Boot_HaxeError.__name__ = ['js', '_Boot', 'HaxeError'];
	js__$Boot_HaxeError.wrap = function (val) {
		if (val instanceof Error) {
			return val;
		} else {
			return new js__$Boot_HaxeError(val);
		}
	};
	js__$Boot_HaxeError.__super__ = Error;
	js__$Boot_HaxeError.prototype = $extend(Error.prototype, {
		__class__: js__$Boot_HaxeError,
	});
	var js_Boot = function () {};
	js_Boot.__name__ = ['js', 'Boot'];
	js_Boot.getClass = function (o) {
		if (o instanceof Array && o.__enum__ == null) {
			return Array;
		} else {
			var cl = o.__class__;
			if (cl != null) {
				return cl;
			}
			var name = js_Boot.__nativeClassName(o);
			if (name != null) {
				return js_Boot.__resolveNativeClass(name);
			}
			return null;
		}
	};
	js_Boot.__string_rec = function (o, s) {
		if (o == null) {
			return 'null';
		}
		if (s.length >= 5) {
			return '<...>';
		}
		var t = typeof o;
		if (t == 'function' && (o.__name__ || o.__ename__)) {
			t = 'object';
		}
		switch (t) {
			case 'function':
				return '<function>';
			case 'object':
				if (o instanceof Array) {
					if (o.__enum__) {
						if (o.length == 2) {
							return o[0];
						}
						var str = o[0] + '(';
						s += '\t';
						var _g1 = 2;
						var _g = o.length;
						while (_g1 < _g) {
							var i = _g1++;
							if (i != 2) {
								str += ',' + js_Boot.__string_rec(o[i], s);
							} else {
								str += js_Boot.__string_rec(o[i], s);
							}
						}
						return str + ')';
					}
					var l = o.length;
					var i1;
					var str1 = '[';
					s += '\t';
					var _g11 = 0;
					var _g2 = l;
					while (_g11 < _g2) {
						var i2 = _g11++;
						str1 += (i2 > 0 ? ',' : '') + js_Boot.__string_rec(o[i2], s);
					}
					str1 += ']';
					return str1;
				}
				var tostr;
				try {
					tostr = o.toString;
				} catch (e) {
					return '???';
				}
				if (
					tostr != null &&
					tostr != Object.toString &&
					typeof tostr == 'function'
				) {
					var s2 = o.toString();
					if (s2 != '[object Object]') {
						return s2;
					}
				}
				var k = null;
				var str2 = '{\n';
				s += '\t';
				var hasp = o.hasOwnProperty != null;
				for (var k in o) {
					if (hasp && !o.hasOwnProperty(k)) {
						continue;
					}
					if (
						k == 'prototype' ||
						k == '__class__' ||
						k == '__super__' ||
						k == '__interfaces__' ||
						k == '__properties__'
					) {
						continue;
					}
					if (str2.length != 2) {
						str2 += ', \n';
					}
					str2 += s + k + ' : ' + js_Boot.__string_rec(o[k], s);
				}
				s = s.substring(1);
				str2 += '\n' + s + '}';
				return str2;
			case 'string':
				return o;
			default:
				return String(o);
		}
	};
	js_Boot.__interfLoop = function (cc, cl) {
		if (cc == null) {
			return false;
		}
		if (cc == cl) {
			return true;
		}
		var intf = cc.__interfaces__;
		if (intf != null) {
			var _g1 = 0;
			var _g = intf.length;
			while (_g1 < _g) {
				var i = intf[_g1++];
				if (i == cl || js_Boot.__interfLoop(i, cl)) {
					return true;
				}
			}
		}
		return js_Boot.__interfLoop(cc.__super__, cl);
	};
	js_Boot.__instanceof = function (o, cl) {
		if (cl == null) {
			return false;
		}
		switch (cl) {
			case Array:
				if (o instanceof Array) {
					return o.__enum__ == null;
				} else {
					return false;
				}
				break;
			case Bool:
				return typeof o == 'boolean';
			case Dynamic:
				return true;
			case Float:
				return typeof o == 'number';
			case Int:
				if (typeof o == 'number') {
					return (o | 0) === o;
				} else {
					return false;
				}
				break;
			case String:
				return typeof o == 'string';
			default:
				if (o != null) {
					if (typeof cl == 'function') {
						if (o instanceof cl) {
							return true;
						}
						if (js_Boot.__interfLoop(js_Boot.getClass(o), cl)) {
							return true;
						}
					} else if (typeof cl == 'object' && js_Boot.__isNativeObj(cl)) {
						if (o instanceof cl) {
							return true;
						}
					}
				} else {
					return false;
				}
				if (cl == Class ? o.__name__ != null : false) {
					return true;
				}
				if (cl == Enum ? o.__ename__ != null : false) {
					return true;
				}
				return o.__enum__ == cl;
		}
	};
	js_Boot.__nativeClassName = function (o) {
		var name = js_Boot.__toStr.call(o).slice(8, -1);
		if (
			name == 'Object' ||
			name == 'Function' ||
			name == 'Math' ||
			name == 'JSON'
		) {
			return null;
		}
		return name;
	};
	js_Boot.__isNativeObj = function (o) {
		return js_Boot.__nativeClassName(o) != null;
	};
	js_Boot.__resolveNativeClass = function (name) {
		return $global[name];
	};
	var js_Browser = function () {};
	js_Browser.__name__ = ['js', 'Browser'];
	js_Browser.getLocalStorage = function () {
		try {
			var s = window.localStorage;
			s.getItem('');
			return s;
		} catch (e) {
			return null;
		}
	};
	js_Browser.createXMLHttpRequest = function () {
		if (typeof XMLHttpRequest != 'undefined') {
			return new XMLHttpRequest();
		}
		if (typeof ActiveXObject != 'undefined') {
			return new ActiveXObject('Microsoft.XMLHTTP');
		}
		throw new js__$Boot_HaxeError('Unable to create XMLHttpRequest object.');
	};
	var js_html_compat_ArrayBuffer = function (a) {
		if (a instanceof Array && a.__enum__ == null) {
			this.a = a;
			this.byteLength = a.length;
		} else {
			var len = a;
			this.a = [];
			var _g1 = 0;
			var _g = len;
			while (_g1 < _g) this.a[_g1++] = 0;
			this.byteLength = len;
		}
	};
	js_html_compat_ArrayBuffer.__name__ = ['js', 'html', 'compat', 'ArrayBuffer'];
	js_html_compat_ArrayBuffer.sliceImpl = function (begin, end) {
		var u = new Uint8Array(this, begin, end == null ? null : end - begin);
		var result = new ArrayBuffer(u.byteLength);
		new Uint8Array(result).set(u);
		return result;
	};
	js_html_compat_ArrayBuffer.prototype = {
		slice: function (begin, end) {
			return new js_html_compat_ArrayBuffer(this.a.slice(begin, end));
		},
		__class__: js_html_compat_ArrayBuffer,
	};
	var js_html_compat_Uint8Array = function () {};
	js_html_compat_Uint8Array.__name__ = ['js', 'html', 'compat', 'Uint8Array'];
	js_html_compat_Uint8Array._new = function (arg1, offset, length) {
		var arr;
		if (typeof arg1 == 'number') {
			arr = [];
			var _g1 = 0;
			var _g = arg1;
			while (_g1 < _g) {
				var i = _g1++;
				arr[i] = 0;
			}
			arr.byteLength = arr.length;
			arr.byteOffset = 0;
			arr.buffer = new js_html_compat_ArrayBuffer(arr);
		} else if (js_Boot.__instanceof(arg1, js_html_compat_ArrayBuffer)) {
			var buffer = arg1;
			if (offset == null) {
				offset = 0;
			}
			if (length == null) {
				length = buffer.byteLength - offset;
			}
			if (offset == 0) {
				arr = buffer.a;
			} else {
				arr = buffer.a.slice(offset, offset + length);
			}
			arr.byteLength = arr.length;
			arr.byteOffset = offset;
			arr.buffer = buffer;
		} else if (arg1 instanceof Array && arg1.__enum__ == null) {
			arr = arg1.slice();
			arr.byteLength = arr.length;
			arr.byteOffset = 0;
			arr.buffer = new js_html_compat_ArrayBuffer(arr);
		} else {
			throw new js__$Boot_HaxeError('TODO ' + Std.string(arg1));
		}
		arr.subarray = js_html_compat_Uint8Array._subarray;
		arr.set = js_html_compat_Uint8Array._set;
		return arr;
	};
	js_html_compat_Uint8Array._set = function (arg, offset) {
		if (js_Boot.__instanceof(arg.buffer, js_html_compat_ArrayBuffer)) {
			var a = arg;
			if (arg.byteLength + offset > this.byteLength) {
				throw new js__$Boot_HaxeError('set() outside of range');
			}
			var _g1 = 0;
			var _g = arg.byteLength;
			while (_g1 < _g) {
				var i = _g1++;
				this[i + offset] = a[i];
			}
		} else if (arg instanceof Array && arg.__enum__ == null) {
			var a1 = arg;
			if (a1.length + offset > this.byteLength) {
				throw new js__$Boot_HaxeError('set() outside of range');
			}
			var _g11 = 0;
			var _g2 = a1.length;
			while (_g11 < _g2) {
				var i1 = _g11++;
				this[i1 + offset] = a1[i1];
			}
		} else {
			throw new js__$Boot_HaxeError('TODO');
		}
	};
	js_html_compat_Uint8Array._subarray = function (start, end) {
		var a = js_html_compat_Uint8Array._new(this.slice(start, end));
		a.byteOffset = start;
		return a;
	};
	var oneconnect_sdk_SimplePromise = function () {
		this.succeeded = false;
		this.failed = false;
	};
	oneconnect_sdk_SimplePromise.__name__ = [
		'oneconnect',
		'sdk',
		'SimplePromise',
	];
	oneconnect_sdk_SimplePromise.prototype = {
		then: function (callback) {
			if (this.succeeded) {
				callback(this.result);
			}
			this.success = callback;
			return this;
		},
		catchError: function (callback) {
			if (this.failed) {
				callback(this.error);
			}
			this.fail = callback;
			return this;
		},
		resolve: function (result) {
			if (this.succeeded || this.failed) {
				throw new js__$Boot_HaxeError('Promise is already fulfilled');
			}
			this.succeeded = true;
			this.result = result;
			if (this.success != null) {
				this.success(result);
			}
		},
		reject: function (error) {
			if (this.succeeded || this.failed) {
				throw new js__$Boot_HaxeError('Promise is already fulfilled');
			}
			this.failed = true;
			this.error = error;
			if (this.fail != null) {
				this.fail(error);
			}
		},
		__class__: oneconnect_sdk_SimplePromise,
	};
	var oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$ = {};
	oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.__name__ = [
		'oneconnect',
		'sdk',
		'_RefreshResponse',
		'RefreshResponse_Impl_',
	];
	oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.isError = function (
		this1
	) {
		return Object.prototype.hasOwnProperty.call(this1, 'error');
	};
	oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.getError = function (
		this1
	) {
		if (
			oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.isError(this1)
		) {
			return this1;
		}
		throw new js__$Boot_HaxeError('Unable to handle auth data as error.');
	};
	oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.getAuth = function (
		this1
	) {
		if (
			!oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.isError(this1)
		) {
			return this1;
		}
		throw new js__$Boot_HaxeError('Unable to handle error as auth data.');
	};
	var oneconnect_sdk_Sdk = ($hx_exports['oneconnect']['Sdk'] = function () {});
	oneconnect_sdk_Sdk.__name__ = ['oneconnect', 'sdk', 'Sdk'];
	oneconnect_sdk_Sdk.setStyle = function (containerCss) {
		oneconnect_sdk_Sdk.get_visual().setStyle(containerCss);
	};
	oneconnect_sdk_Sdk.authenticate = function (options) {
		var promise = new oneconnect_sdk_SimplePromise();
		oneconnect_sdk_Sdk
			.get_silent()
			.authenticate(options)
			.then($bind(promise, promise.resolve))
			.catchError(function (_) {
				oneconnect_sdk_Sdk
					.forceAuthenticate(options)
					.then($bind(promise, promise.resolve))
					.catchError($bind(promise, promise.reject));
			});
		return promise;
	};
	oneconnect_sdk_Sdk.forceAuthenticate = function (options) {
		var promise = new oneconnect_sdk_SimplePromise();
		oneconnect_sdk_Sdk
			.get_visual()
			.authenticate(options)
			.catchError($bind(promise, promise.reject))
			.then(function (data) {
				oneconnect_sdk_Sdk.get_storage().populate(data);
				promise.resolve(data);
			});
		return promise;
	};
	oneconnect_sdk_Sdk.openCustomPage = function (options, pageId, payload) {
		var promise = new oneconnect_sdk_SimplePromise();
		oneconnect_sdk_Sdk
			.get_visual()
			.openCustomPage(options, pageId, payload)
			.catchError($bind(promise, promise.reject))
			.then(function (data) {
				oneconnect_sdk_Sdk.get_storage().populate(data);
				promise.resolve(data);
			});
		return promise;
	};
	oneconnect_sdk_Sdk.logout = function () {
		oneconnect_sdk_Sdk.get_silent().logout();
	};
	oneconnect_sdk_Sdk.get_visual = function () {
		if (oneconnect_sdk_Sdk._visual == null) {
			return (oneconnect_sdk_Sdk._visual = new oneconnect_sdk_VisualApi());
		} else {
			return oneconnect_sdk_Sdk._visual;
		}
	};
	oneconnect_sdk_Sdk.get_silent = function () {
		if (oneconnect_sdk_Sdk._silent == null) {
			return (oneconnect_sdk_Sdk._silent = new oneconnect_sdk_SilentApi(
				oneconnect_sdk_Sdk.get_storage()
			));
		} else {
			return oneconnect_sdk_Sdk._silent;
		}
	};
	oneconnect_sdk_Sdk.get_storage = function () {
		if (oneconnect_sdk_Sdk._storage == null) {
			return (oneconnect_sdk_Sdk._storage = new oneconnect_sdk_Storage());
		} else {
			return oneconnect_sdk_Sdk._storage;
		}
	};
	var oneconnect_sdk_SilentApi = function (storage) {
		this.storage = storage;
	};
	oneconnect_sdk_SilentApi.__name__ = ['oneconnect', 'sdk', 'SilentApi'];
	oneconnect_sdk_SilentApi.prototype = {
		authenticate: function (options) {
			var promise = new oneconnect_sdk_SimplePromise();
			if (this.storage.get_refreshToken() == null) {
				promise.reject(this.errorMsg('NOT_LOGGED_IN'));
			} else if (
				!options.useRefreshOnEachSilentAuthentication &&
				!this.isAccessTokenExpired()
			) {
				promise.resolve(this.createAuthDataOfStoredSession());
			} else {
				this.refresh(options)
					.then($bind(promise, promise.resolve))
					.catchError($bind(promise, promise.reject));
			}
			return promise;
		},
		logout: function () {
			this.storage.clear();
			return;
		},
		refresh: function (options) {
			var _gthis = this;
			var promise = new oneconnect_sdk_SimplePromise();
			var request = js_Browser.createXMLHttpRequest();
			request.onreadystatechange = function () {
				if (request.readyState == 4) {
					var _g = _gthis.processRefreshResponse(
						request.status,
						request.responseText
					);
					switch (_g[1]) {
						case 0:
							promise.resolve(_g[2]);
							break;
						case 1:
							promise.reject(_g[2]);
							break;
					}
				}
			};
			var _g1 = new haxe_ds_StringMap();
			var value = this.storage.get_refreshToken();
			if (__map_reserved['refresh_token'] != null) {
				_g1.setReserved('refresh_token', value);
			} else {
				_g1.h['refresh_token'] = value;
			}
			if (__map_reserved['grant_type'] != null) {
				_g1.setReserved('grant_type', 'refresh_token');
			} else {
				_g1.h['grant_type'] = 'refresh_token';
			}
			var value1 = options.clientId;
			if (__map_reserved['client_id'] != null) {
				_g1.setReserved('client_id', value1);
			} else {
				_g1.h['client_id'] = value1;
			}
			var value2 = options.language;
			if (__map_reserved['lang'] != null) {
				_g1.setReserved('lang', value2);
			} else {
				_g1.h['lang'] = value2;
			}
			var value3 = options.sessionId;
			if (__map_reserved['session_id'] != null) {
				_g1.setReserved('session_id', value3);
			} else {
				_g1.h['session_id'] = value3;
			}
			var tmp = this.buildUrl(options.refreshUrl, _g1);
			request.open('POST', tmp);
			request.send();
			return promise;
		},
		processRefreshResponse: function (statusCode, responseText) {
			if (responseText != null) {
				var response;
				try {
					response = JSON.parse(responseText);
				} catch (e) {
					response = null;
				}
				if (response != null) {
					if (
						statusCode == 400 &&
						oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.isError(
							response
						)
					) {
						var err =
							oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.getError(
								response
							);
						if (err.error == 'account_banned') {
							this.storage.clear();
							return haxe_ds_Either.Right(
								this.errorMsg('USER_BANNED', err.error_description)
							);
						}
					}
					if (
						!oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.isError(
							response
						)
					) {
						var result =
							oneconnect_sdk__$RefreshResponse_RefreshResponse_$Impl_$.getAuth(
								response
							);
						this.storage.populate(result);
						return haxe_ds_Either.Left(result);
					}
				}
			}
			if (!this.isAccessTokenExpired()) {
				return haxe_ds_Either.Left(this.createAuthDataOfStoredSession());
			}
			return haxe_ds_Either.Right(this.errorMsg('SERVICE_UNAVAILABLE'));
		},
		isAccessTokenExpired: function () {
			return new Date().getTime() > this.storage.get_expireTimestamp();
		},
		buildUrl: function (url, params) {
			var glue = url.indexOf('?') < 0 ? '?' : '&';
			var _g = [];
			var param = params.keys();
			while (param.hasNext()) {
				var param1 = param.next();
				_g.push(
					'' +
						param1 +
						'=' +
						(__map_reserved[param1] != null
							? params.getReserved(param1)
							: params.h[param1])
				);
			}
			return url + glue + _g.join('&');
		},
		createAuthDataOfStoredSession: function () {
			return {
				access_token: this.storage.get_accessToken(),
				refresh_token: this.storage.get_refreshToken(),
				ocid: this.storage.get_ocid(),
				expires_in:
					((this.storage.get_expireTimestamp() - new Date().getTime()) / 1000) |
					0,
			};
		},
		errorMsg: function (exitCode, message) {
			return { exitCode: exitCode, message: message };
		},
		__class__: oneconnect_sdk_SilentApi,
	};
	var oneconnect_sdk_Storage = function () {
		this.storage = js_Browser.getLocalStorage();
	};
	oneconnect_sdk_Storage.__name__ = ['oneconnect', 'sdk', 'Storage'];
	oneconnect_sdk_Storage.prototype = {
		populate: function (data) {
			if (this.storage != null) {
				this.storage.setItem('oneconnect.accessToken', data.access_token);
				this.storage.setItem('oneconnect.refreshToken', data.refresh_token);
				this.storage.setItem('oneconnect.ocid', data.ocid);
				this.storage.setItem(
					'oneconnect.expireTimestamp',
					Std.string(new Date().getTime() + (data.expires_in - 60) * 1000)
				);
			}
		},
		clear: function () {
			if (this.storage != null) {
				this.storage.removeItem('oneconnect.accessToken');
				this.storage.removeItem('oneconnect.refreshToken');
				this.storage.removeItem('oneconnect.ocid');
				this.storage.removeItem('oneconnect.expireTimestamp');
			}
		},
		get_accessToken: function () {
			if (this.storage == null) {
				return null;
			} else {
				return this.storage.getItem('oneconnect.accessToken');
			}
		},
		get_refreshToken: function () {
			if (this.storage == null) {
				return null;
			} else {
				return this.storage.getItem('oneconnect.refreshToken');
			}
		},
		get_expireTimestamp: function () {
			if (this.storage == null) {
				return 0;
			} else {
				var value = parseFloat(
					this.storage.getItem('oneconnect.expireTimestamp')
				);
				if (value == null) {
					return 0;
				} else {
					return value;
				}
			}
		},
		get_ocid: function () {
			if (this.storage == null) {
				return null;
			} else {
				return this.storage.getItem('oneconnect.ocid');
			}
		},
		__class__: oneconnect_sdk_Storage,
	};
	var oneconnect_sdk_VisualApi = function () {};
	oneconnect_sdk_VisualApi.__name__ = ['oneconnect', 'sdk', 'VisualApi'];
	oneconnect_sdk_VisualApi.prototype = {
		setStyle: function (containerCss) {
			this.containerCss = containerCss;
		},
		authenticate: function (options) {
			return this.createFrame(
				this.buildUrl(options),
				this.containerCss
			).onFinish();
		},
		openCustomPage: function (options, pageId, payload) {
			return this.createFrame(
				this.buildUrl(options) +
					('&page=' + pageId + '&payload=') +
					encodeURIComponent(payload),
				this.containerCss
			).onFinish();
		},
		createFrame: function (url, containerCss) {
			var back = window.document.createElement('div');
			back.id = 'oneconnect-back';
			back.setAttribute(
				'style',
				'\r\n\t\t\t\tposition:absolute;\r\n\t\t\t\ttop:0px;\r\n\t\t\t\tleft:0px;\r\n\t\t\t\twidth:100%;\r\n\t\t\t\theight:100%;\r\n\t\t\t\tpadding:0px;\r\n\t\t\t\tmargin:0px;\r\n\t\t\t\tbackground:rgba(0, 0, 0, 0.5);\r\n\t\t\t'
			);
			this.blockClickThrough(back);
			var div = window.document.createElement('div');
			var frame = window.document.createElement('iframe');
			div.appendChild(frame);
			back.appendChild(div);
			window.document.body.appendChild(back);
			if (containerCss == null) {
				div.setAttribute(
					'style',
					'position:absolute;width:100%;height:100%;margin:0%;padding:0%;'
				);
			} else if (new EReg('^[-_A-Za-z0-9 ]+$', '').match(containerCss)) {
				div.setAttribute('class', containerCss);
			} else {
				div.setAttribute('style', containerCss);
			}
			frame.setAttribute('style', 'width:100%;height:100%;');
			frame.src = url;
			return new oneconnect_sdk__$VisualApi_Frame(url, back, div, frame);
		},
		buildUrl: function (options) {
			var baseUrl = options.baseUrl;
			if (baseUrl.charAt(baseUrl.length - 1) != '/') {
				baseUrl += '/';
			}
			var url =
				'' +
				baseUrl +
				'index.html?platform=' +
				options.platform +
				'&lang=' +
				options.language +
				'&client_id=' +
				options.clientId +
				'&session_id=' +
				options.sessionId +
				'&rnd=' +
				Math.random();
			if (options.email != null) {
				url += '&email=' + options.email;
			}
			if (options.passwordHash != null) {
				url += '&passwordHash=' + options.passwordHash;
			}
			if (options.pageId != null) {
				url += '&page=' + options.pageId;
			}
			return url;
		},
		blockClickThrough: function (element) {
			var blockEvent = function (e) {
				e.stopPropagation();
			};
			element.onmousedown = blockEvent;
			element.onmouseenter = blockEvent;
			element.onmouseleave = blockEvent;
			element.onmousemove = blockEvent;
			element.onmouseout = blockEvent;
			element.onmouseover = blockEvent;
			element.onmouseup = blockEvent;
			element.ontouchcancel = blockEvent;
			element.ontouchend = blockEvent;
			element.ontouchmove = blockEvent;
			element.ontouchstart = blockEvent;
		},
		__class__: oneconnect_sdk_VisualApi,
	};
	var oneconnect_sdk__$VisualApi_Frame = function (
		url,
		container,
		frameContainer,
		frame
	) {
		this.finished = false;
		this.promise = new oneconnect_sdk_SimplePromise();
		this.disposed = false;
		this.url = url;
		this.container = container;
		this.frameContainer = frameContainer;
		this.frame = frame;
		this.createCloseBtn();
		window.addEventListener('message', $bind(this, this.messageReceived));
	};
	oneconnect_sdk__$VisualApi_Frame.__name__ = [
		'oneconnect',
		'sdk',
		'_VisualApi',
		'Frame',
	];
	oneconnect_sdk__$VisualApi_Frame.prototype = {
		onFinish: function () {
			return this.promise;
		},
		dispose: function () {
			this.disposed = true;
			window.removeEventListener('message', $bind(this, this.messageReceived));
			this.closeBtn.removeEventListener(
				'click',
				$bind(this, this.closeClicked)
			);
			if (this.container.parentElement != null) {
				this.container.parentElement.removeChild(this.container);
			}
		},
		hideCloseBtn: function () {
			this.closeBtn.style.display = 'none';
		},
		createCloseBtn: function () {
			this.closeBtn = window.document.createElement('a');
			var img = window.document.createElement('img');
			img.src =
				'data:image/png;base64, ' +
				haxe_crypto_Base64
					.encode(haxe_Resource.getBytes('close.png'))
					.toString();
			img.setAttribute('style', 'width:100%;height:100%;');
			this.closeBtn.appendChild(img);
			this.closeBtn.setAttribute(
				'style',
				'position:absolute;display:block;width:23.72pt;height:23.72pt;right:23.73pt;top:19.54pt;'
			);
			this.closeBtn.href = '#';
			this.frameContainer.appendChild(this.closeBtn);
			this.closeBtn.addEventListener('click', $bind(this, this.closeClicked));
		},
		messageReceived: function (msg) {
			if (this.url.indexOf(msg.origin) != 0) {
				return;
			}
			var result = msg.data;
			if (this.shouldIgnoreServiceMessage(result)) {
				return;
			}
			if (this.isHideCloseBtnMessage(result)) {
				this.hideCloseBtn();
				return;
			}
			this.dispose();
			var _g = result.exitCode;
			if (_g == null) {
				this.fail('UNKNOWN_ERROR');
			} else if (_g == 'AUTHENTICATION_SUCCESS') {
				this.success(result.message);
			} else {
				this.fail(result);
			}
		},
		closeClicked: function () {
			this.closeBtn.removeEventListener(
				'click',
				$bind(this, this.closeClicked)
			);
			this.dispose();
			this.fail('USER_CANCELED');
		},
		success: function (auth) {
			if (this.finished) {
				return;
			}
			this.finished = true;
			this.promise.resolve(auth);
		},
		fail: function (reason) {
			if (this.finished) {
				return;
			}
			this.finished = true;
			this.promise.reject(reason);
		},
		shouldIgnoreServiceMessage: function (msg) {
			if (!(msg == null || typeof msg == 'string')) {
				return !this.isAnyPropertyInitialized(msg);
			} else {
				return true;
			}
		},
		isAnyPropertyInitialized: function (msg) {
			if (!(msg.message != null || msg.action != null)) {
				return msg.exitCode != null;
			} else {
				return true;
			}
		},
		isHideCloseBtnMessage: function (msg) {
			return msg.action == 'hideCloseButton';
		},
		__class__: oneconnect_sdk__$VisualApi_Frame,
	};
	var $_,
		$fid = 0;

	function $bind(o, m) {
		if (m == null) return null;
		if (m.__id__ == null) m.__id__ = $fid++;
		var f;
		if (o.hx__closures__ == null) o.hx__closures__ = {};
		else f = o.hx__closures__[m.__id__];
		if (f == null) {
			f = function () {
				return f.method.apply(f.scope, arguments);
			};
			f.scope = o;
			f.method = m;
			o.hx__closures__[m.__id__] = f;
		}
		return f;
	}

	String.prototype.__class__ = String;
	String.__name__ = ['String'];
	Array.__name__ = ['Array'];
	Date.prototype.__class__ = Date;
	Date.__name__ = ['Date'];
	var Int = { __name__: ['Int'] };
	var Dynamic = { __name__: ['Dynamic'] };
	var Float = Number;
	Float.__name__ = ['Float'];
	var Bool = Boolean;
	Bool.__ename__ = ['Bool'];
	var Class = { __name__: ['Class'] };
	var Enum = {};
	haxe_Resource.content = [
		{
			name: 'close.png',
			data: 'iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAYAAAAcjSspAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAA2NJREFUeJzV3L+LHGUcwOEnbwRNQBFN/gER7OUICCJRyIlCNII/ighJd6XYKChCmlSCoKWFhoCFITEKgoVwQsBCC0sRIhZWkqCSwotYBIt3Xzlidm9n5v2+M/Mpd999Z/aB253lvXn3bW1tWXQXTuEkHsXd+AWX8D5+N/8O4XWcwEP4Gz/gHD7BLdi3QHkQn+PxJZNdx4u4EnnGwT2Bizi85PkreA43EvYvBi8DsZjoKzxZ8SRbdkw+/2UgZLTPkBJexdE1Jj6IL80P5pj8V3BwjbFP4ZUkf46s29xguoCUTif5Q7VLc4HpAwJHEu7pccCpw/QFgQMJP/c88FRhNvUHgZ/SYoK+TQ1mE5f1B4HLCe/J1yF9mwpMDZDf8EHCH3gBOwMmGxumBshf8pXun2nxwLc4bp4wtUCexXeQdj2xbX4wNUH++wmTbhswJ5gQEP6PwjxgwkC4MwrThgkFYTkK04QJB2E1CtOCaQLC3ihMA6YZCOuhMC5MUxDWR2EcmOYgdEOhLcwoIHRHoQ3MaCD0QyEWZlQQ+qMQAzM6CMNQqAvzlgmAMByFejBnTQCEOijUgRlSNRDqoTAeTFUQ6qLQHqY6CPVRaAcTAkIMCvEwYSDEoRAHEwpCLAr1YXYEgxCPQoY5W2muMxr841ALlE28XWmuMxosn0Sj1Pgts7smyyeRKLVBSuEwUShRIKVQmAiUaJBSGExtlFYgpRCYmiitQUrVYWqhjAVSqgpTA6UGyA7eMI2VyMEotUCewbvGX4nEMJSaIOXSfQpLtL1RIkBKo8P0QYkEKY0K0xWlBUhpNJguKC1BSqPArIsyBkipOcw6KGOClJrC7IUyBZBSM5hVKFMCKTWBWYYy9PYQ6oOUwmHuhFJADgw4aBRIKRTmdpQ5gJTCYHajzAmkFAJTUI6aH0ipJsxjZJRDuGCeIKVaMF/ggSTf+7/qzu69GhukVAPmMF5LeH7AJFMBKdWAOZHwcM8XTw2kNBTmkSRvl9G1qYKUhsDcTPL+IV2aOkipL8z3CR93eMFcQEp9YM4leYeZ7TUGzw2k1AXma3ya5C13Xrb6zV6Xr3jnBlLaxtO4tmLMN3gJt/ZvbGzATZyX92C6F/ctBv6ID+V9mq4GnXCrfsVH+Af3y+/xhnyj+jt40+JL519/ylwGGfZmYgAAAABJRU5ErkJggg',
		},
	];
	var __map_reserved = {};
	var ArrayBuffer = $global.ArrayBuffer || js_html_compat_ArrayBuffer;
	if (ArrayBuffer.prototype.slice == null) {
		ArrayBuffer.prototype.slice = js_html_compat_ArrayBuffer.sliceImpl;
	}
	var Uint8Array = $global.Uint8Array || js_html_compat_Uint8Array._new;
	haxe_crypto_Base64.CHARS =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	haxe_crypto_Base64.BYTES = haxe_io_Bytes.ofString(haxe_crypto_Base64.CHARS);
	js_Boot.__toStr = {}.toString;
	js_html_compat_Uint8Array.BYTES_PER_ELEMENT = 1;
	oneconnect_sdk_Sdk.VERSION = '3.0.3';
})(
	typeof exports != 'undefined'
		? exports
		: typeof window != 'undefined'
			? window
			: typeof self != 'undefined'
				? self
				: this,
	typeof window != 'undefined'
		? window
		: typeof global != 'undefined'
			? global
			: typeof self != 'undefined'
				? self
				: this
);
